import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState, userMenuAccess } from './auth.model';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectUser = createSelector(
  selectAuthState,
  (state: AuthState) => state.user
);

export const selectUserId = createSelector(
  selectAuthState,
  (state: AuthState) => state.id
);

export const selectToken = createSelector(
  selectAuthState,
  (state: AuthState) => state.token
);

export const selectIsLoading = createSelector(
  selectAuthState,
  (state: AuthState) => state.isLoading
);

export const selectError = createSelector(
  selectAuthState,
  (state: AuthState) => state.error
);

export const selectIsAuthenticated = createSelector(
  selectToken,
  (token) => !!token
);

export const selectPermissions = createSelector(
  selectAuthState,
  (state: AuthState) => state.permissions as userMenuAccess
);


export const selectMenuTree = createSelector(
  selectPermissions,
  (permissions) => permissions?.menu_tree ?? []
);

export const selectSlugs = createSelector(
  selectPermissions,
  (permissions) => permissions?.slug_array ?? {}
);

